import type { ChangeOrderLineItem, ChangeOrderLinePayload } from '@/types/changeOrder';

/**
 * A change-order line as it may be sent on a create or update.
 *
 * Lines read back from a saved change order carry `snapshotTimestamp`, which
 * the server stamps whenever it stores a line. Echoing it back is what made
 * every edit of a draft with an added line fail with "Fix the Snapshot
 * Timestamp" — a field the user cannot see or change (NOT-783). The server owns
 * that stamp, so it is never sent.
 */
export function toChangeOrderLinePayload(line: ChangeOrderLineItem): ChangeOrderLinePayload {
  const { snapshotTimestamp: _serverOwned, ...payload } = line;
  return payload;
}
